import React from 'react';
import { useNavigate } from 'react-router-dom';
import useSafeBackNavigation from '../hooks/useSafeBackNavigation';

function PaymentCancel() {
  const navigate = useNavigate();
  const handleBack = useSafeBackNavigation('/training');

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 text-center">
        {/* Cancel Icon */}
        <div className="w-20 h-20 bg-amber-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>

        <h1 className="text-3xl font-bold text-white mb-2">
          Paiement Annulé
        </h1>
        <p className="text-gray-300 mb-8">
          Vous avez annulé le processus de paiement. Aucun montant n'a été débité.
        </p>

        {/* Info Box */}
        <div className="bg-blue-500/20 border border-blue-500/50 rounded-lg p-4 mb-6 text-left">
          <h3 className="text-blue-300 font-semibold mb-2">💡 Pourquoi passer au Premium ?</h3>
          <ul className="text-blue-200 text-sm space-y-1">
            <li>• Accès à tous les modules de formation</li>
            <li>• Coach IA illimité (écrit et vocal)</li>
            <li>• Scénarios immersifs personnalisés</li>
            <li>• 1 jour d'essai gratuit</li>
          </ul>
        </div>

        <div className="space-y-3">
          <button
            onClick={() => navigate('/subscription', { state: { from: '/training' } })}
            className="w-full bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white font-bold py-3 px-6 rounded-xl transition-all duration-200 transform hover:scale-105"
          >
            Réessayer le paiement
          </button>

          <button
            onClick={handleBack}
            className="w-full bg-white/10 hover:bg-white/20 text-white font-semibold py-3 px-6 rounded-xl transition-colors border border-white/20"
          >
            Retour au tableau de bord
          </button>
        </div>

        <p className="text-gray-400 text-sm mt-6">
          Besoin d'aide ? Contactez notre support à support@Coach-dia.com
        </p>
      </div>
    </div>
  );
}

export default PaymentCancel;
